require('/dev/shm/odin/app/frontend/components/countdown/index.module.scss');